import {
  DISMISS_SHARED_LINK_RESTORE_BANNER,
  SHARED_LINK_RESTORE_FAILED,
  SHARED_LINK_RESTORE_NEEDS_REVIEW,
  SharedLinkRestoreStatus,
  SharedLinkRestoreStatusAction
} from '../actions/shared_link_restore_status'
import { LOAD_UPGRADE_PLAN } from '../actions/load_upgrade_plan'
import { CLEAR_PRODUCTS_ACTION } from '../chosen_products/clear_products_action'
import { AnyAction } from 'redux'

// Widened past SharedLinkRestoreStatusAction because this reducer also has to watch two
// actions it does not own, to know when its own message has gone stale.
export default function sharedLinkRestoreStatus(sharedLinkRestoreStatus: SharedLinkRestoreStatus = SharedLinkRestoreStatus.NONE, action: SharedLinkRestoreStatusAction | AnyAction): SharedLinkRestoreStatus {
  switch (action.type) {
  case SHARED_LINK_RESTORE_FAILED:
    return SharedLinkRestoreStatus.RESTORE_FAILED
  case SHARED_LINK_RESTORE_NEEDS_REVIEW:
    return SharedLinkRestoreStatus.NEEDS_REVIEW
  case DISMISS_SHARED_LINK_RESTORE_BANNER:
    return SharedLinkRestoreStatus.NONE
  // Both messages describe how the page got here and what to do next, so both go stale the
  // moment the user moves past that. Without these the "you must generate a plan" banner
  // sits above a rendered plan, and "restored from a shared link" survives a pasted report
  // that replaced every product. Matches the recommendation bubble, which the Generate Plan
  // click and a target-version change both clear.
  case LOAD_UPGRADE_PLAN:
  case CLEAR_PRODUCTS_ACTION:
    return SharedLinkRestoreStatus.NONE
  default:
    return sharedLinkRestoreStatus
  }
}
